import {ItemIconDict} from "../../../gd/const/item-icon/icon/icons";
import {ProjectIconDictionary} from "../../../gd/const/project";
import {ProjectSystemType, ProjectSystemTypeIcon} from "../types";

export default function project_getIconClass(projectIcon: string, systemType?: ProjectSystemType) {
    if (projectIcon) {
        let className= ItemIconDict[projectIcon]?.className

        if (!className) {
            console.log('#dkdhs8333 no icon in ItemIconDict found icon=', projectIcon)
            // Bez etogo beryetsya ot "system type". Ne ponyatno kak togda emoji pokazat.
            return false
        } else {
            return className
        }
    }

    // no icon set - get system icon from system type
    return systemType ? ProjectIconDictionary[ProjectSystemTypeIcon[systemType] as keyof object] : false
}